import { render } from "./manage-categories.vue?vue&type=template&id=2fa4a9dc"
import script from "./manage-categories.vue?vue&type=script&lang=js"
export * from "./manage-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__